/**
 * 企业对账周期
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/enterprisereconciliation/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import ReconciliationModal from '../modal/ReconciliationModal';

class Main extends React.Component {

    state = {
        tel: undefined,
        enterpriseName: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        openModeParam: {},
        currentOpenMode: ''
    }

    // 查询
    _searchHandle = (useCache) => {
        const { tel, enterpriseName, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            tel,
            epName: enterpriseName,
            beginRegisterTime: startTime,
            endRegisterTime: endTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getEnterpriseCycleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ tel: undefined, enterpriseName: undefined, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case ta.detail:
                sessionStorage.setItem('enterprisereconciliation', curTabID);
                history.push({ pathname: `/home/finance/enterprisereconciliation/reconciliationcycle/detail/${item.userId}/${item.id}` });
                break;
            case ta.sure:
                this.setState({ currentOpenMode: ta.sure, openModeParam: { id: key } });
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.sure:
                return <ReconciliationModal title='对账周期' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        const { tel, enterpriseName, startTime, endTime } = this.state;
        let { curTabID, enterpriseCycleList } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='手机号'
                                placeholder='请输入'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='企业名称'
                                placeholder='请输入'
                                value={enterpriseName}
                                bindThis={this}
                                bindName='enterpriseName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='注册时间'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                showTime={false}
                                defaultTime='00:00:00'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={enterpriseCycleList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
                {this._renderMode()}
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getEnterpriseCycleList: PropTypes.func,
    enterpriseCycleList: PropTypes.object
};
const mapStateToProps = (state) => ({
    enterpriseCycleList: state.enterprisereconciliation.enterpriseCycleList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);